/**
 * @author Ashok
 * @author Azzeta Karmacharya
 */
import React, { Component } from "react";
import IncreaseDecreaseTerm from "./IncreaseDecreaseTerm";
import { NepaliDatePicker } from "nepali-calander";

class CreateAcademicYearForm extends Component {
  render() {
    return (
      <div className="container-fluid ttacademic-form">
        <div className="row">
          <div className="col-md-4">
            <label>
              <strong>Start date : </strong>
            </label>
            <NepaliDatePicker
              type="input"
              calendarMode={localStorage.getItem('calendar-mode')}
              showToggle={true}
              showNationalHoliday={false}
              events={[]}
              onDateSelect={!this.props.config
                ? (date) => {
                  this.props.handleAcademicYearChange(
                    {
                      target: { value: date.ad.date, name: "startDate", 'id': this.props.startDateId, 'data-id': { id: this.props.dataId } }
                    }
                  )
                }
                : null
              }
              value={
                this.props.startDate
              }
              maxDate={this.props.endDate}
            /> 
          </div>
          <div className="col-md-4">
            <label>
              <strong>End date : </strong>
            </label>
            <NepaliDatePicker
              type="input"
              calendarMode={localStorage.getItem('calendar-mode')}
              showToggle={true}
              showNationalHoliday={false}
              events={[]}
              onDateSelect={!this.props.config
                ? (date) => {
                  this.props.handleAcademicYearChange(
                    {
                      target: { value: date.ad.date, name: "endDate", 'id': this.props.EndDateId, 'data-id': { id: this.props.dataId } }
                    }
                  )
                }
                : null
              }
              value={
                this.props.endDate
              }
              minDate={this.props.startDate}
            /> 
          </div>

          <div className="col-md-4">
            <label>
              <strong>Number of {this.props.termAlias}s :</strong>
            </label>
            <IncreaseDecreaseTerm
              numberOfTerms={this.props.numberOfTerms}
              decreaseValue={this.props.decreaseValue}
              numberOfSemester={this.props.numberOfSemester}
              increaseValue={this.props.increaseValue}
              levelName={this.props.levelName}
              idx={this.props.dataId}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CreateAcademicYearForm;
